module.exports = __webpack_public_path__ + "static/pr_pra-7ae6c4e8123b9e90bd755f7877735fb6.png";